import { checkSession } from "@features/auth";
import { preloadQuery } from "@relay";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import type { endRentalPageQuery } from "../swap/__generated__/endRentalPageQuery.graphql";
import { EndRentalPage, query } from "../swap/end-rental.$reservationId";

export const Route = createFileRoute("/$hubMetaName/lock/end-rental/$reservationId")({
	beforeLoad: () => {
		document.title = "bacehub | Lock";
	},
	component: RouteComponent,
	validateSearch: zodValidator(z.object({ source: z.literal("b2c").optional() })),
	loader: async (ctx) => {
		if (!(await checkSession())) {
			throw redirect({
				to: "/auth",
				search: { redirectToPath: `/${ctx.params.hubMetaName}/lock${ctx.location.searchStr}` },
			});
		}
		return preloadQuery<endRentalPageQuery>(ctx.context.relayEnvironment, query, {
			reservationId: ctx.params.reservationId,
		});
	},
});

function RouteComponent() {
	const { hubMetaName, reservationId } = Route.useParams();
	return (
		<EndRentalPage
			queryRef={Route.useLoaderData()}
			hubMetaName={hubMetaName}
			reservationId={reservationId}
			source="b2c"
			service="LOCK_B2C"
		/>
	);
}
